(function () {
  const FBT_SELECTOR = '[data-fbt-container]';
  const MAX_ITEMS = 6;
  const BLACKLIST_TAGS = ['hidden', 'addon', '3d hoodie', 'dark t-shirt', 'light t-shirt', 'ugly christmas sweater'];

  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Network error: ' + url);
    return res.json();
  }

  async function fetchHTML(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Network error: ' + url);
    return res.text();
  }

  function getCurrentHandle() {
    const match = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return match && match[1] ? match[1] : '';
  }

  async function getCurrentProduct() {
    const handle = getCurrentHandle();
    if (!handle) return null;

    return fetchJSON(`/products/${handle}.js`);
  }

  function removeCurrentProduct(container) {
    const handle = getCurrentHandle();
    if (!handle) return;

    const items = container.querySelectorAll('.cart-drawer-fbt__item');

    items.forEach((item) => {
      const link = item.querySelector('a[href*="/products/"]');
      if (!link) return;

      const href = link.getAttribute('href') || link.pathname || '';
      const match = href.match(/\/products\/([^\/\?]+)/);

      if (match && match[1] === handle) {
        item.remove();
      }
    });
  }

  function trimToMax(container, max) {
    const items = container.querySelectorAll('.cart-drawer-fbt__item');
    items.forEach((item, index) => {
      if (index >= max) item.remove();
    });

    if (!container.querySelector('.cart-drawer-fbt__item')) {
      container.innerHTML = '';
    }
  }

  async function loadCartFBT() {
    const containers = document.querySelectorAll(FBT_SELECTOR);
    if (!containers.length) return;

    try {
      const product = await getCurrentProduct();
      if (!product || !Array.isArray(product.tags) || !product.tags.length) {
        containers.forEach((c) => (c.innerHTML = ''));
        return;
      }

      // Lấy tất cả tag, bỏ hidden / addon
      const usableTags = product.tags.filter((t) => {
        if (!t) return false;
        const lower = String(t).toLowerCase();
        return !BLACKLIST_TAGS.includes(lower);
      });

      if (!usableTags.length) {
        containers.forEach((c) => (c.innerHTML = ''));
        return;
      }

      // Ghép query: tag:christmas OR tag:"3d hoodie" OR ...
      const terms = usableTags
        .slice(0, 6) // tránh query quá dài
        .map((t) => {
          const tagStr = String(t).trim();
          // Nếu tag có khoảng trắng → bọc trong dấu "
          if (/\s/.test(tagStr)) {
            return `tag:"${tagStr.replace(/"/g, '\\"')}"`;
          }
          return `tag:${tagStr}`;
        });

      const queryString = terms.join(' OR ');
      const titleForBlock = product.title || '';

      containers.forEach((c) => {
        c.innerHTML =
          '<p class="cart-drawer-fbt__loading">Loading suggestions…</p>';
      });

      const searchUrl =
        `/search?type=product` +
        `&q=${encodeURIComponent(queryString)}` +
        `&view=fbt-cart`;

      // Debug (nếu cần xem trong console)
      console.log('[FBT] tags =', usableTags, 'URL =', searchUrl);

      const html = await fetchHTML(searchUrl);
      if (!html.trim()) {
        containers.forEach((c) => (c.innerHTML = ''));
        return;
      }

      const finalHTML = `
        <h3 class="cart-drawer-fbt__title">
          🔥 Frequently bought with
          <span>${titleForBlock}</span>
        </h3>
        ${html}
      `;

      containers.forEach((c) => {
        c.innerHTML = finalHTML;
        removeCurrentProduct(c);   // Xóa chính product đang xem
        trimToMax(c, MAX_ITEMS);   // Giữ tối đa 6 item
      });
    } catch (e) {
      console.error('[FBT error]', e);
      const containers = document.querySelectorAll(FBT_SELECTOR);
      containers.forEach((c) => (c.innerHTML = ''));
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadCartFBT();

    // Sau mỗi lần Add to cart trên product page → reload FBT
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest(
        'form[action="/cart/add"] button[type="submit"]'
      );
      if (btn) {
        setTimeout(loadCartFBT, 700);
      }
    });
  });
})();
